import * as React from 'react';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';

export class BasicGridToolbar extends React.Component<any> {

  render() {
    const {
      title = 'Data Grid',
      addRow,
      saveAll,
      saving,
      sx
    } = this.props;

    return (
      <Box
        sx={{
          backgroundColor: '#bbd4e6',
          borderBottom: '1px solid #d0d7de',
          px: 2,
          py: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          minHeight: 48,
          ...sx
        }}
      >

        {/* LEFT TITLE */}
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 600,
            color: '#16324f'
          }}
        >
          {title}
        </Typography>

        {/* RIGHT ACTIONS */}
        <Box sx={{ display: 'flex', gap: 1 }}>

          <Tooltip title="Add record">
            <IconButton size="small" onClick={addRow}>
              <AddIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Save changes">
            <IconButton
              size="small"
              onClick={saveAll}
              disabled={saving}
            >
              <SaveIcon />
            </IconButton>
          </Tooltip>

        </Box>

      </Box>
    );
  }
}



// import * as React from 'react';
// import { Box, Tooltip } from '@mui/material';
// import AddIcon from '@mui/icons-material/Add';
// import SaveIcon from '@mui/icons-material/Save';
// import { Toolbar, ToolbarButton } from '@mui/x-data-grid';

// export class BasicGridToolbar extends React.Component<any> {
//   render() {
//     const { addRow, saveAll, saving, sx } = this.props;

//     return (
//       <Box
//         sx={{
//           backgroundColor: '#bbd4e6',
//           borderBottom: '1px solid #d0d7de',
//           px: 1,
//           py: 0.5,
//           minHeight: 42,
//           display: 'flex',
//           //alignItems: 'center',
//           ...sx,
//         }}
//       >
//         <Toolbar>
//           <Tooltip title="Add record">
//             <ToolbarButton onClick={addRow}>
//               <AddIcon fontSize="small" />
//             </ToolbarButton>
//           </Tooltip>

//           <Tooltip title="Save Changes">
//             <ToolbarButton onClick={saveAll} disabled={saving}>
//               <SaveIcon fontSize="small" />
//             </ToolbarButton>
//           </Tooltip>
//         </Toolbar>
//       </Box>
//     );
//   }
// }

// export class BasicGridToolbar extends React.Component<any> {

//   render(){
//     const {addRow,saveAll,saving} = this.props;
//     return (
//       <Toolbar>
//         <Tooltip title="Add record">
//           <ToolbarButton onClick={addRow}>
//             <AddIcon fontSize="small" />
//           </ToolbarButton>
//         </Tooltip>
//         <Tooltip title="Save Changes">
//           <ToolbarButton onClick={saveAll} disabled={saving}>
//             <SaveIcon fontSize="small" />
//           </ToolbarButton>
//         </Tooltip>
//         {/* <Tooltip title="Save Changes">
//           <Button
//             variant="contained"
//             onClick={saveAll}
//             disabled={saving}
//           >
//             Save Changes
//           </Button>
//         </Tooltip> */}
//       </Toolbar>
//     );
//   }
// }

